{
  "title": "Expeditious Retreat",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level transmutation",
  "level": 1,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "This spell allows you to move at an incredible pace. When you cast this spell, and then as a bonus action on each of your turns until the spell ends, you can take the Dash action."
  ],
  "spellLists": ["artificer", "sorcerer", "warlock", "wizard"]
}
